import script from "./MobileHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileHome.vue?vue&type=script&setup=true&lang=js"

import "./MobileHome.vue?vue&type=style&index=0&id=47883166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47883166"]])

export default __exports__